export default "__VITE_ASSET__DWKk3h6j__"